import React, { Component } from "react";

class FooterComponent extends Component {
  render() {
    return (
      <div className="container">
        <span className="mx-auto text-white-50">Author: @vadimzubchenko</span>
      </div>
    );
  }
}

export default FooterComponent;
